import React, { useState, useEffect } from 'react';
import {
  Drawer,
  IconButton,
  Typography,
  Box,
  Divider,
  CircularProgress,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import AgentStaticTasks from '../AgentStaticTasks';

const DRAWER_WIDTH = 800;

const AgentStaticTasksDrawer = ({ open, onClose, agent }) => {
  const [isLoading, setIsLoading] = useState(false);

  // Use tenant_agent_instance_id for API/scoping (each row is independent); fallback for legacy
  const agentKey = agent?.tenantAgentInstanceId ?? agent?.agentUniqueId ?? agent?.agentName ?? null;
  // Real agent name for display only (never show the unique id as "agent name" in the drawer)
  const agentDisplayName = agent?.agentName ?? null;

  useEffect(() => {
    if (open) {
      setIsLoading(false);
    }
  }, [open]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: DRAWER_WIDTH },
          maxWidth: '100%',
        },
      }}
    >
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: 1,
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6">
            Static Tasks{agentDisplayName ? ` - ${agentDisplayName}` : ''}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>

        <Box sx={{ px: 2, py: 1, bgcolor: 'action.hover' }}>
          <Typography variant="caption" color="text.secondary">
            Use Run to test a task immediately. Results appear in Task Queue.
          </Typography>
        </Box>
        <Divider />

        {/* Content - agentKey (tenantAgentInstanceId) scopes tasks to this tenant agent instance */}
        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          {isLoading ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box sx={{ flex: 1, overflow: 'auto' }}>
              <AgentStaticTasks
                agentName={agentKey}
                agentDisplayName={agentDisplayName}
                drawerMode={true}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default AgentStaticTasksDrawer;
